export enum PartnerServicesEnum {
  PARTNER_SERVICES_IN_PERSON_SEE_MORE = 'partner-services-in-person--see-more',
  PARTNER_SERVICES_TELEHEALTH_SEE_MORE = 'partner-services-telehealth--see-more',
  PARTNER_SERVICES_PRICE_MODAL = 'partner-services-price-modal',
  PARTNER_SERVICES_SLOTS_MODAL = 'partner-services-slots-modal',
}
